import axios from './common/axios';

// 検索履歴取得のリクエストを１回に制限するためのグローバルな状態を管理するオブジェクト
window.__searchHistoriesState = window.__searchHistoriesState || {
  cachedHistories: null,
  historyPromise: null
};

export default {
  searchProducts(params, callback) {
    axios
      .get('/search/api/products', {
        params
      })
      .then(function (res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  previouslyInCart(params, callback) {
    axios
      .get('/shop/previously_in_your_cart', {
        params
      })
      .then(function (res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  recentlyViewedItems(params, callback) {
    axios
      .get('/shop/recently_viewed_items', {
        params
      })
      .then(function (res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  artcleRelatedItemsOrRankingItems(params, callback) {
    axios
      .get('/news/products_area', {
        params
      })
      .then(function (res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /**
   * 検索履歴を取得する。
   *
   * `/search/api/histories`エンドポイントからデータを取得し、取得したデータをグローバルにキャッシュする。
   * 複数回呼び出された場合でも、`axios.get('/search/api/histories')`は一度だけ呼び出され、以降はキャッシュされた結果が返される。
   *
   * @returns {Promise<Object>} 検索履歴
   */
  histories() {
    const state = window.__searchHistoriesState;

    if (state.cachedHistories) {
      // キャッシュされた結果がある場合、それを即座に返す
      return Promise.resolve(state.cachedHistories);
    }

    if (state.historyPromise) {
      // リクエストが進行中の場合、進行中のPromiseを返す
      return state.historyPromise;
    }

    // 新しいリクエストを開始
    state.historyPromise = axios
      .get('/search/api/histories')
      .then((response) => {
        state.cachedHistories = response.data;
        state.historyPromise = null;
        return state.cachedHistories;
      })
      .catch((err) => {
        state.historyPromise = null;
        throw err;
      });

    return state.historyPromise;
  }
};
